var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.enabled && _vm.active),expression:"enabled && active"}],staticClass:"tabContent"},[_vm._t("default",null,{"tab":this})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }